module.exports = __webpack_public_path__ + "media/images/crosswords/pos3-d53395ada0f401d25c747f5f472b573e.png";